import React, { useState, useEffect } from 'react';
import { Card, Modal } from 'antd';
import cn from 'classnames';

import ContentItemActions from './ContentItemActions';
import CardImg from '@components/snippets/CardImg';
import { FileTypeTranslate } from '../../../constants/FileType';
import { SWAGGER_URL } from '../../../api';

const { Meta } = Card;

function ContentItem({
  t,
  onShow,
  onDelete,
  name,
  type,
  url,
  largeThumb,
  smallThumb,
  width,
  height,
}) {
  const [error, setError] = useState(null);
  const onError = () =>
    Modal.error({
      title: t('cant-remove-content'),
      centered: true,
      content: (
        <div>
          <p>{t('cant-remove-content')}</p>
        </div>
      ),
      okText: t('close'),
    });

  if (process.env.NODE_ENV === 'development') {
    largeThumb = largeThumb
      ? SWAGGER_URL + '/' + largeThumb
      : smallThumb || url;
  }

  useEffect(() => {
    if (error) setError(null);
  }, [url]);

  return (
    <Card
      className="content-item"
      bordered={false}
      cover={
        <div
          className={cn('content-item__cover', {
            'content-item__cover--border-radius': !largeThumb,
          })}
        >
          <CardImg
            className="content-item__image"
            name={name}
            url={url}
            largeThumb={largeThumb}
            smallThumb={smallThumb}
          />
          <div
            className={cn('content-item__overlay', {
              'content-item__overlay--rounded': !(
                !error &&
                (largeThumb || smallThumb || url)
              ),
            })}
          >
            <ContentItemActions
              t={t}
              type={type}
              url={url}
              onShow={onShow}
              onDelete={onDelete}
              onError={onError}
            />
          </div>
        </div>
      }
    >
      <Meta className="content-item__title" title={name} />
      <div className="content-item__description">
        <span>{FileTypeTranslate[type](t)}</span>
        {width && height && (
          <span>
            {width}x{height}
          </span>
        )}
      </div>
    </Card>
  );
}

export default ContentItem;
